import { render, staticRenderFns } from "./OfficeForm.vue?vue&type=template&id=60d718b7&"
import script from "./OfficeForm.vue?vue&type=script&lang=js&"
export * from "./OfficeForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficeForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports